export default __webpack_public_path__ + "static/media/Arte_305_Bust.1a7544fb.png";